import { render, staticRenderFns } from "./aftersalelist.vue?vue&type=template&id=3af18bb4&"
import script from "./aftersalelist.vue?vue&type=script&lang=js&"
export * from "./aftersalelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports